import { observable } from "mobx";

import { QuizObjectCardTable } from "./quiz-object-card-table";

class QuizObjectCard {
    @observable _id: string | undefined = undefined;
    @observable title: string = "";
    @observable definition: string = "";
    @observable subjectHashKey: string = "";
    @observable order: number | undefined = undefined;
    quizObjectTable: QuizObjectCardTable | undefined = undefined;

    constructor(quizObjectCardTable: QuizObjectCardTable, card?: any) {        
        this.quizObjectTable = quizObjectCardTable;
        this.subjectHashKey = quizObjectCardTable.subjectHashKey;

        if (card) {
            this._id = card._id;
            this.title = card.title;
            this.definition = card.definition;
            if (card.order) {
                this.order = card.order;
            }
        }
    }

    setDefinition(definition: string) {
        this.definition = definition;
    }

    setTitle(title: string) {
        this.title = title;
    }

    get link() {
        return `/subjects/${this.subjectHashKey}/o/${this._id}`
    }

    toJSON() {
        return {
            _id: this._id,
            definition: this.definition,
            order: this.order,
            title: this.title,
        };
    }
}

export { QuizObjectCard };
